export const GET_SESSION_MEDIAS = "GET_SESSION_MEDIAS";
export const GET_SESSION_MEDIA_BY_ID = "GET_SESSION_MEDIA_BY_ID";
export const UPDATE_SESSION_MEDIA = "UPDATE_SESSION_MEDIA";
export const DELETE_SESSION_MEDIA = "DELETE_SESSION_MEDIA";
export const CREATE_SESSION_MEDIA = "CREATE_SESSION_MEDIA";
